import {
  Divider,
  GKDatePicker,
  GKSearchSelect,
  Grid2,
  Typography,
} from "components";
import dayjs from "dayjs";
import {
  EquitybasketFormInterface,
  EquityBasketListInterface,
} from "interfaces/EquityBasket";
import { Controller, useFormContext } from "react-hook-form";
import { MODEL_PORTFOLIO_REBALANCING_TIME } from "utils/constants";

const RebalanceTab = ({ data }: { data: EquityBasketListInterface }) => {
  const form = useFormContext<EquitybasketFormInterface>();

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={4}>
        <Controller
          name="rebalanceTime"
          control={form.control}
          render={({ field }) => {
            return (
              <GKSearchSelect
                {...field}
                inputLabel="Frequency"
                placeholder="Frequency"
                options={MODEL_PORTFOLIO_REBALANCING_TIME || []}
                getOptionLabel={(d) => d?.name || d}
                onChange={(e, val) => field.onChange(val?.value)}
              />
            );
          }}
        />
      </Grid2>
      <Grid2 size={4}>
        <Controller
          name="nextRebalanceDate"
          control={form.control}
          render={({ field }) => {
            return (
              <GKDatePicker
                {...field}
                inputLabel={`Next ${data?.basketType === "Asset" ? "Recommendation" : "Rebalance"} Date`}
                value={dayjs(field.value)}
                disableFuture={false}
                onChange={(value) => {
                  field.onChange(dayjs(value).format("YYYY-MM-DD"));
                }}
              />
            );
          }}
        />
      </Grid2>
      <Grid2 size={12}>
        <Divider />
      </Grid2>
      <Grid2 size={12}>
        <Typography color={"var(--neutral-500)"}>
          Last {data?.basketType === "Asset" ? "Recommendation" : "Rebalance"}{" "}
          Date:
          <span
            style={{
              color: "var(--black)",
              fontWeight: 600,
            }}
          >
            {" "}
            {data?.lastRebalanceDate ||
              `The basket has not been ${data?.basketType === "Asset" ? "recommendation" : "rebalance"}`}
          </span>
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default RebalanceTab;
